import { render, staticRenderFns } from "./BalanceChart.vue?vue&type=template&id=0fdb9765&scoped=true"
import script from "./BalanceChart.vue?vue&type=script&lang=js"
export * from "./BalanceChart.vue?vue&type=script&lang=js"
import style0 from "./BalanceChart.vue?vue&type=style&index=0&id=0fdb9765&prod&lang=scss"
import style1 from "./BalanceChart.vue?vue&type=style&index=1&id=0fdb9765&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb9765",
  null
  
)

export default component.exports